import { useState } from 'react';
import InitFilters from './DiscountCodes/constants/InitFiltering';

const useCustomHook = () => {
  const [voucherType, setVoucherType] = useState('amount'); // "percentage" or "amount"
  const [consumeType, setConsumeType] = useState('DISPOSABLE_ITEM'); // "DISPOSABLE_ITEM" or "DISPOSABLE_INVOICE" or "UNLIMITED"
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedDealers, setSelectedDealers] = useState([]);
  const [dataService, setDataService] = useState([]);
  const [targetUser, setTargetUser] = useState(null);

  const [activeStep, setActiveStep] = useState(0);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [callReq, setCallReq] = useState(false);
  const [isOpenMessageCartableDg, setIsOpenMessageCartableDg] = useState(false);

  const [generatedVouchers, setGeneratedVouchers] = useState([]);
  const [dataToExport, setDataToExport] = useState([]);
  const [titlesToExport, setTitlesToExport] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [code, setCode] = useState(null);

  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [, setGuildsList] = useState([]);
  const [guildListLoading, setGuildListLoading] = useState(false);
  const [requestId, setRequestId] = useState(null);
  const [filters, setFilters] = useState(InitFilters());
  const [paramsData, setParamsData] = useState(null);

  return {
    paramsData, setParamsData,
    requestId, setRequestId,
    voucherType,
    setVoucherType,
    consumeType,
    setConsumeType,
    selectedProducts,
    setSelectedProducts,
    selectedDealers,
    setSelectedDealers,
    targetUser,
    setTargetUser,
    activeStep,
    setActiveStep,
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    guildListLoading,
    setGuildListLoading,
    filters,
    setFilters,
    size,
    setSize,
    setGuildsList,
    code,
    setCode,
    isConfirmOpen,
    setIsConfirmOpen,
    generatedVouchers,
    setGeneratedVouchers,
    dataToExport,
    setDataToExport,
    titlesToExport,
    setTitlesToExport,
    totalCount,
    setTotalCount,
    dataService, setDataService,
    isOpenMessageCartableDg, setIsOpenMessageCartableDg,
    page,
    setPage,
    callReq, setCallReq
  };
};

export default useCustomHook;
